import React from 'react';
import styles from './ApplicatorsWidget.module.scss';

import _ from 'lodash';
import moment from 'moment';

import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';
import Loader from 'components/miscellaneous/Loader/Loader';
import { $t } from 'helpers/translator';
import { Link } from 'react-router-dom';
import { IoOpenOutline } from 'react-icons/io5';
import api from "helpers/api";


class ApplicatorsWidget extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
            slideIndex: 0,
            // startDate: moment(this.props.startDate).format('YYYY-MM-DD'),
            // endDate: moment(this.props.endDate).format('YYYY-MM-DD'),
        };
    }

    async componentDidMount() {
        await this.init();
    }

    async init() {
        try {
            let res = await api.get('dashboard/applicators');
            // console.log('dashboard/applicators', res)
            if (res && res.success) {
                this.buildItemsArray(res.data.data);
                // this.setState({data: res.data.data}, () => {
                //     this.buildItemsArray(this.state.data);
                // });
            }
        } catch (e) {
            console.error('err basic data');
        }


        // if (this.props.data && !this.state.data) {
        //     this.buildItemsArray(this.props['data']['data']);
        // }
    }

    buildItemsArray(data) {
        // console.log('aaa>>', this.props)
        let items = [];

        _.forEach(data, (handle, k) => {
            items.push(
                <div className={`${styles['handle-container']} d-flex`}>
                    <div className={styles['image-container']}>
                        <img src={handle.image}/>
                    </div>

                    <div className={styles['text-container']}>
                        <div className={styles['serial-container']}>
                            {handle.serial_number ? handle.serial_number : 'N/A'}
                        </div>
                        <div className={styles['name-container']}>
                            {handle.handle_type_name}
                        </div>
                        <div className={styles['pulses-container']}>
                            Pulses: {handle.pulses}
                        </div>
                    </div>
                </div>
            );
        });

        this.setState({ data: items }, () => {
        });
    };

    render() {
        const responsive = {
            0: { items: 2 },
        };

        return (
            <div>
                <div>
                    {!this.state.data &&
                    <Loader color="#ddd" />
                    }

                    {this.state.data &&
                    <AliceCarousel
                        mouseTracking
                        items={this.state.data}
                        responsive={responsive}
                        disableButtonsControls={false}
                        disableDotsControls={true}
                        controlsStrategy="responsive"
                    />
                    }
                </div>
            </div>
        );
    }
}

export default ApplicatorsWidget;
